import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { apiInstance } from "@/shared/api";
import { HeadContact } from "../model";

export const useHeadContact = () => {
  return useQuery({
    queryKey: ["headContact"],
    queryFn: async () => {
      return await apiInstance.get<{ data: HeadContact }>(
        "/head-contacts",
        undefined,
        true,
      );
    },
  });
};

export const useUpsertHeadContact = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["upsertHeadContact"],
    mutationFn: async (data: { contact: string }) => {
      return await apiInstance.patch<{ data: HeadContact }>(
        "/head-contacts/upsert",
        data,
        undefined,
        true,
      );
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["headContact"] });
    },
  });
};
